export default __webpack_public_path__ + "static/media/efuse_ecoSwitch.2e05f179.svg";